// src/styles/media.ts (수정된 코드)

import { css, RuleSet, Interpolation } from 'styled-components'; // 필요한 타입 임포트

const sizes = {
  // mobile: 768,
  tablet: 768, 
  desktop: 1440,
};

// media 객체의 최종 타입을 명시적으로 정의 (가독성을 위해)
type MediaKeys = keyof typeof sizes;

// 미디어 쿼리 헬퍼 함수
export const media = (Object.keys(sizes) as Array<MediaKeys>).reduce((acc, label) => {
//                                     ^^^^^^^^^^^^^^^^^^^^
//                                     여기서 키 타입을 명시적으로 캐스팅

  acc[label] = (...args: Parameters<typeof css>) => css`
    @media (min-width: ${sizes[label]}px) {
      ${css(...args)};
    }
  `;
  // acc의 타입을 올바르게 추론하도록 최종 타입을 명시합니다.
  return acc;
}, {} as Record<MediaKeys, (...args: Parameters<typeof css>) => RuleSet<object>>);

// 참고: TypeScript 4.0 이상에서는 css 타입이 자동으로 추론되므로,
// RuleSet, Styles, Interpolation 임포트 없이도 동작할 수 있습니다.